import config from '../../../config';

export const convertArrayToSearchString = (options, type) => {
  let optionsString = '';
  options.forEach((o, index) => {
    if (index === options.length - 1) {
      optionsString = optionsString + o;
    } else {
      optionsString = optionsString + o + ',';
    }
  });

  const finalString = (type ? type + ':' : '') + optionsString;
  return finalString;
};

const convertLabelsToSuggestionsKeysSearchString = labels => {
  const suggestionsOptions = config.custom.suggestionCategoryOptions;
  const filtered = labels.filter(l => suggestionsOptions.find(x => x.label === l));
  const converted = filtered.map(f => suggestionsOptions.find(x => x.label === f).key);

  const type = 'has_any';
  const searchString = convertArrayToSearchString(converted, type);
  return searchString;
};

export const convertSuggestionsStringTotripReasonValue = currentSuggestionsParams => {
  const tripReasonsKeys = config.custom.tripReasonOptions;
  const predictions = tripReasonsKeys.map(t => {
    return {
      key: t.key,
      suggentionsString: getPredictionsFromCategory(t.key),
    };
  });

  const foundTripReason = predictions.find(s => s.suggentionsString === currentSuggestionsParams);
  return foundTripReason?.key;
};

export const convertMultipleSelectQueryStringToArray = queryString => {
  if (!queryString) {
    return null;
  }
  const types = ['has_all:', 'has_any:'];
  types.forEach(t => {
    queryString = queryString.replace(t, '');
  });
  const finalArray = queryString.split(',');
  return finalArray;
};

export const convertQueryParamsToChips = (queryParams, allOptions) => {
  // TODO improve this to work for single select filters too
  const entries = Object.entries(queryParams);
  const chips = entries.map(e => {
    const mainKey = e[0];
    const mainValue = e[1];
    const types = ['has_all:', 'has_any:'];

    //multiple select case
    if (typeof mainValue === 'string' && types.find(t => mainValue.includes(t))) {
      const arrayOfValues = convertMultipleSelectQueryStringToArray(mainValue);
      const subArrayOfChips = arrayOfValues.map(x => {
        const label = allOptions.find(l => l.key === x)?.label;
        return {
          searchKey: mainKey,
          value: x,
          label: label,
        };
      });

      return subArrayOfChips;
    } else if (typeof mainValue === 'string' && mainKey === 'price') {
      const priceValues = mainValue.split(',');
      const label = `$${priceValues[0]} - $${priceValues[1]}`;
      return {
        searchKey: mainKey,
        value: mainValue,
        label: label,
      };
    }
  });

  const flattenChips = chips.flat();
  return flattenChips;
};
